import { render, staticRenderFns } from "./order-detail-card.vue?vue&type=template&id=7c0f5fb8&scoped=true&"
import script from "./order-detail-card.vue?vue&type=script&lang=js&"
export * from "./order-detail-card.vue?vue&type=script&lang=js&"
import style0 from "./order-detail-card.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./order-detail-card.vue?vue&type=style&index=1&id=7c0f5fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0f5fb8",
  null
  
)

export default component.exports